import './notificationModal.scss';
import { NOTIFICATION_ACTION_TYPES } from 'helpers/constants';
import NobelDashboardModal from '../nobelDashboardModal';
import { NotificationInfo } from './notificationInfo';
import { AddNotification } from './addNotification';
import { EditNotification } from './editNotification';

function NotificationModal({
	notification,
	setNotification,
	actionType,
	setActionType,
	isOpen,
	closeHandler,
	className = '',
}) {
	// After the send is queued, open its detail to follow the progress
	const openSentNotification = (notificationId) => {
		setNotification({ id: notificationId });
		setActionType(NOTIFICATION_ACTION_TYPES.NOTIFICATION_INFO);
	};

	return (
		<NobelDashboardModal isOpen={isOpen} onRequestClose={closeHandler}>
			<div className={'NotificationModal' + className}>
					{actionType === NOTIFICATION_ACTION_TYPES.NOTIFICATION_INFO && (
						<>
							<h3 className="NotificationModal__title">Notification Info</h3>
							<NotificationInfo
								notificationId={notification?.id}
								setAction={setActionType}
								onRequestClose={closeHandler}
							/>
						</>
					)}
					{actionType === NOTIFICATION_ACTION_TYPES.ADD_NOTIFICATION && (
						<>
							<h3 className="NotificationModal__title">New Notification</h3>
							<AddNotification
								onRequestClose={closeHandler}
								onSent={openSentNotification}
							/>
						</>
					)}
					{actionType === NOTIFICATION_ACTION_TYPES.EDIT_NOTIFICATION && (
						<>
							<h3 className="NotificationModal__title">Edit Notification</h3>
							<EditNotification
								notification={notification}
								setAction={setActionType}
								onRequestClose={closeHandler}
							/>
						</>
					)}
				</div>
		</NobelDashboardModal>
	);
}

export default NotificationModal;
